import { DOMAIN } from '../utils/server'

export const DOMAIN_NAME = `https://www.${DOMAIN}.com`

export const HOME_PAGE = 'home'
export const NOT_FOUND_PAGE = '404'

export const ABOUT_PAGE = 'about'
export const RULES_PAGE = 'rules'
export const GUIDES_PAGE = 'guides'
export const PUZZLES_PAGE = 'puzzles'
export const DEMO_PAGE = 'demo'

export const ADMIN_PAGE = 'admin'
